// check if URL contains 'gswpromo'
if (window.location.href.includes('gswpromo')) {
    document.addEventListener('DOMContentLoaded', function() {
        setupDialog();
    });
}

const hideFromScreenReaderAndTab = [
    'main', 
    'footer', 
    '.search',
];

function lockFocus() {
    hideFromScreenReaderAndTab.forEach(selector => {
        document.querySelectorAll(selector).forEach(element => {
            element.setAttribute('aria-hidden', 'true');
            element.setAttribute('tabindex', '-1');
        });
    });
}

function unlockFocus() {
    hideFromScreenReaderAndTab.forEach(selector => {
        document.querySelectorAll(selector).forEach(element => {
            element.removeAttribute('aria-hidden');
            element.removeAttribute('tabindex');
        });
    });
}

function setupDialog() {
    var trigger = document.getElementById('gsw-disclaimer-trigger');
    var dialog = document.getElementById('gsw-disclaimer-wrap');
    var close = document.querySelector('.gsw-disclaimer-close');

    if (!dialog) {
        return;
    }

    var focusableElements = Array.prototype.slice.call(dialog.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'));
    var firstFocusableElement = focusableElements[0];
    var lastFocusableElement = focusableElements[focusableElements.length - 1];

    function openDialog() {
        dialog.classList.add('dialog-open');
        dialog.style.display = 'block';
        dialog.setAttribute('aria-hidden', 'false');
        dialog.removeAttribute('tabindex');
        lockFocus(); // hide other elements
        close.focus();
        document.addEventListener('keydown', trapTabKey);
    }
  
    function closeDialog() {
        dialog.classList.remove('dialog-open');
        dialog.style.display = 'none';
        dialog.setAttribute('aria-hidden', 'true');
        dialog.setAttribute('tabindex', '-1');
        unlockFocus(); // reveal other elements
        trigger.focus();
        document.removeEventListener('keydown', trapTabKey);
    }

    function trapTabKey(e) {
        var isTabPressed = e.key === 'Tab' || e.keyCode === 9;
        if (!isTabPressed) {
          return;
        }
    
        if (e.shiftKey) {
          if (document.activeElement === firstFocusableElement) {
            e.preventDefault();
            lastFocusableElement.focus();
          }
        } else {
          if (document.activeElement === lastFocusableElement) {
            e.preventDefault();
            firstFocusableElement.focus();
          }
        }
    }

    function handleEscKey(e) {
        if (e.key === 'Escape' || e.keyCode === 27) {
            closeDialog();
        }
    }

    trigger.addEventListener('click', openDialog);
    close.addEventListener('click', closeDialog);
    document.addEventListener('keydown', handleEscKey);
  
}

document.addEventListener('DOMContentLoaded', setupDialog);

